import {
  Component, ChangeDetectionStrategy, Input, HostBinding,
} from '@angular/core'
import { CommonModule } from '@angular/common'
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon'
import { BytesPipe } from '@knorr-bremse-portals/ngx-components/pipes/bytes'
import {
  iconFileTypeAvi, iconFileTypeDoc, iconFileTypeExe, iconFileTypeGif, iconFileTypeJpg, iconFileTypeMp3, iconFileTypeMp4, iconFileTypePdf, iconFileTypePng, iconFileTypePpt, iconFileTypeXls, iconFileTypeZip, iconChainRotate, iconDownload, iconArrowsRight, iconFileTypeEps,
} from '@knorr-bremse-portals/icons'

const fileTypeIcons = {
  avi: iconFileTypeAvi,
  doc: iconFileTypeDoc,
  exe: iconFileTypeExe,
  gif: iconFileTypeGif,
  jpg: iconFileTypeJpg,
  mp3: iconFileTypeMp3,
  mp4: iconFileTypeMp4,
  pdf: iconFileTypePdf,
  png: iconFileTypePng,
  ppt: iconFileTypePpt,
  xls: iconFileTypeXls,
  zip: iconFileTypeZip,
  eps: iconFileTypeEps,
  link: iconChainRotate,
}

export type FileTypeIcon = keyof typeof fileTypeIcons

@Component({
  selector: 'a[kb-download-link]',
  templateUrl: './download-link.component.html',
  styleUrls: ['./download-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IconComponent, BytesPipe],
})
export class DownloadLinkComponent {
  @Input()
  public bytes?: number

  @Input()
  public fileType?: FileTypeIcon

  @HostBinding('attr.download') private download = '' // needed to enable focus style

  protected iconDownload = iconDownload

  protected iconArrowsRight = iconArrowsRight

  protected fileTypeIcons = fileTypeIcons
}
